import { HostClientType, } from '@office-start/metaos-hub-sdk';
export const hostClientType = (() => {
    return window.chrome && window.chrome.webview
        ? HostClientType.desktop
        : HostClientType.web;
})();
export function GetLocaleInfo(locale = null) {
    var _a, _b;
    const globalization = (() => {
        var _a;
        return (_a = window === null || window === void 0 ? void 0 : window.Office) === null || _a === void 0 ? void 0 : _a.Globalization;
    })();
    const formatParam = (type) => {
        return locale ? { locale, type } : type;
    };
    return {
        platform: (_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.platform,
        regionalFormat: (_b = globalization === null || globalization === void 0 ? void 0 : globalization.getLocaleInfo(formatParam('name'))) !== null && _b !== void 0 ? _b : navigator.language,
        shortDate: globalization === null || globalization === void 0 ? void 0 : globalization.getLocaleInfo(formatParam('shortdate')),
        longDate: globalization === null || globalization === void 0 ? void 0 : globalization.getLocaleInfo(formatParam('longdate')),
        shortTime: globalization === null || globalization === void 0 ? void 0 : globalization.getLocaleInfo(formatParam('shorttime')),
        longTime: globalization === null || globalization === void 0 ? void 0 : globalization.getLocaleInfo(formatParam('longtime')), // ?? 'HH:mm:ss z',
    };
}
//# sourceMappingURL=appContextUtils.js.map